module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancy-not":"Empty List"}}')
  delete Component.options._Ctor
}
